import { Route, Routes } from "react-router-dom";

import { NotFoundPage } from "./system/NotFoundPage";
import { SpacesModule } from "./SpacesModule";
import { SpacesPage } from "../features/spaces/pages/spaces-home-page/SpacesPage";

/** The signed-in routes inside the shell. Unknown addresses render the real Not found in place. */
export function AppRoutingModule() {
  return (
    <Routes>
      <Route path="/spaces" element={<SpacesPage />} />
      <Route path="/spaces/:spaceId/*" element={<SpacesModule />} />
      <Route path="/notfound" element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
